import SessionType from "../../enums/SessionType.js";

const practiceOnlySessionType = function(sessionType) {
    switch (sessionType) {
        case SessionType.PitchingSession.key:
        case SessionType.BattingSession.key:
        case SessionType.GamePractice.key:
            return true;
    
        default:
            return false;
    }
};

export default practiceOnlySessionType;